// @flow
import * as React from 'react';
import {Link} from 'docs/components';
import Box from 'sail/Box';
import {useVideos} from 'docs/data';
import {Card, CardFooter, CardHeader, CardBody} from './framework';

type VideoPlaylistProps = {|
  playlist: string,
  thumbnail: string,
  id?: string,
  className?: string,
  children?: React.Node,
  href: string,
|};

export const VideoPlaylistCard = ({
  playlist,
  id,
  className = '',
  children,
  href,
}: VideoPlaylistProps) => {
  const videos = useVideos({prefetchAllVideos: true});
  const fetchedPlaylist = videos.getPlaylist(playlist);

  if (!fetchedPlaylist) {
    return null;
  }

  return (
    <Card bordered>
      <Link href={href} title={fetchedPlaylist.title}>
        <Box>
          <CardHeader text={fetchedPlaylist.title} />
          <CardBody>{fetchedPlaylist.description} </CardBody>
        </Box>
        <CardFooter icon={{category: 'general', icon: 'list'}}>
          {`${fetchedPlaylist.chapters.length} videos`}
        </CardFooter>
      </Link>
    </Card>
  );
};
